export class DomainTextModel {
    title_en_GB = '';
    title_de_CH = '';
    intro_de_CH = '';
    intro_en_GB = '';
    characteristics_text_de_CH = '';
    characteristics_text_en_GB = '';
    commonness_text_de_CH = '';
    commonness_text_en_GB = '';
    treatment_approach_text_de_CH = '';
    treatment_approach_text_en_GB = '';
    domain_id = '';
    include_diagnosis_id = '';
    id = '';
}